(() => {
  // Gallery: arrows move the selected thumbnail outline and the main photo.
  const money = (cents) => {
    const value = (Number(cents) / 100).toFixed(2);
    return `$${value.replace(/\.00$/, "")}`;
  };

  const initGallery = (root) => {
    const slides = [...root.querySelectorAll("[data-gallery-slide]")];
    const thumbs = [...root.querySelectorAll("[data-thumb]")];
    const rail = root.querySelector("[data-thumbs-rail]");
    const main = root.querySelector(".wl-gallery__main");
    if (!slides.length || !thumbs.length) return;
    let index = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains("is-active")));
    let lock = false;
    const isMobile = () => window.matchMedia("(max-width: 859px)").matches;
    const scrollToSlide = (i, instant) => {
      if (!main || !isMobile() || !main.clientWidth) return;
      lock = true;
      main.scrollTo({ left: main.clientWidth * i, behavior: instant ? "auto" : "smooth" });
      window.setTimeout(() => { lock = false; }, instant ? 50 : 360);
    };
    const show = (i) => {
      slides.forEach((img, n) => {
        img.classList.toggle("is-on", n === i);
      });
      scrollToSlide(i, false);
    };
    const reveal = (thumb) => {
      if (!rail || !thumb) return;
      const pad = 8;
      const railBox = rail.getBoundingClientRect();
      const thumbBox = thumb.getBoundingClientRect();
      if (thumbBox.right > railBox.right - pad) {
        rail.scrollLeft += thumbBox.right - railBox.right + pad;
      } else if (thumbBox.left < railBox.left + pad) {
        rail.scrollLeft -= railBox.left - thumbBox.left + pad;
      }
    };
    const set = (nextIndex, instant) => {
      index = (nextIndex + thumbs.length) % thumbs.length;
      const thumb = thumbs[index];
      if (!thumb) return;
      thumbs.forEach((btn, i) => btn.classList.toggle("is-active", i === index));
      slides.forEach((img, n) => img.classList.toggle("is-on", n === index));
      scrollToSlide(index, instant);
      reveal(thumb);
    };
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        set(i);
      });
    });
    root.querySelector("[data-gallery-prev]")?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      set(index - 1);
    });
    root.querySelector("[data-gallery-next]")?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      set(index + 1);
    });
    if (main) {
      main.addEventListener("scroll", () => {
        if (!isMobile() || lock || !main.clientWidth) return;
        const next = Math.round(main.scrollLeft / main.clientWidth);
        if (next === index || next < 0 || next >= thumbs.length) return;
        index = next;
        thumbs.forEach((btn, i) => btn.classList.toggle("is-active", i === index));
        slides.forEach((img, n) => img.classList.toggle("is-on", n === index));
        reveal(thumbs[index]);
      }, { passive: true });
    }
    slides.forEach((img, n) => img.classList.toggle("is-on", n === index));
    scrollToSlide(index, true);
  };

  const initOffer = (root) => {
    const bundles = [...root.querySelectorAll("[data-bundle]")];
    const addon = root.querySelector("[data-addon]");
    const totalEls = root.querySelectorAll("[data-total]");
    const compareEls = root.querySelectorAll("[data-compare-total]");
    const installmentEl = root.querySelector("[data-installment]");
    const variantInput = root.querySelector("[data-variant-id]");
    const form = root.querySelector("[data-product-form]");
    const skipCart = root.dataset.skipCart === "true";

    const selectedBundle = () => bundles.find((b) => b.classList.contains("is-on")) || bundles[0];
    const addonOn = () => Boolean(addon?.classList.contains("is-on"));

    const bundleUnits = () => Number(selectedBundle()?.dataset.qty || 1) || 1;

    const renderTotals = () => {
      const bundle = selectedBundle();
      if (!bundle) return;
      const price = Number(bundle.dataset.price || 0);
      const compare = Number(bundle.dataset.compare || 0);
      const units = bundleUnits();
      const unitAddon = Number(addon?.dataset.price || 0);
      const unitAddonCompare = Number(addon?.dataset.compare || 0);
      const addonPrice = addonOn() ? unitAddon * units : 0;
      const addonCompare = addonOn() ? unitAddonCompare * units : 0;
      const total = price + addonPrice;
      const compareTotal = (compare || price) + addonCompare;
      totalEls.forEach((el) => { el.textContent = money(total); });
      compareEls.forEach((el) => { el.textContent = money(compareTotal); });
      if (installmentEl) installmentEl.textContent = (total / 400).toFixed(2).replace(".", ",") + " $";
      if (variantInput) variantInput.value = bundle.dataset.variantId || "";
      const unitLabel = root.querySelector("[data-addon-units]");
      if (unitLabel) unitLabel.textContent = String(units);
      const addonPriceEl = root.querySelector("[data-addon-price]");
      const addonCompareEl = root.querySelector("[data-addon-compare]");
      if (addonPriceEl) addonPriceEl.textContent = money(unitAddon * units);
      if (addonCompareEl) addonCompareEl.textContent = money(unitAddonCompare * units);
    };

    bundles.forEach((bundle) => {
      bundle.querySelector("button")?.addEventListener("click", () => {
        bundles.forEach((b) => b.classList.toggle("is-on", b === bundle));
        renderTotals();
      });
    });
    addon?.addEventListener("click", () => {
      addon.classList.toggle("is-on");
      renderTotals();
    });
    renderTotals();

    form?.addEventListener("submit", async (event) => {
      event.preventDefault();
      const bundle = selectedBundle();
      if (!bundle?.dataset.variantId) return;
      const units = Number(bundle.dataset.qty || 1) || 1;
      const items = [{
        id: Number(bundle.dataset.variantId),
        quantity: units,
        properties: { _units: "1" },
      }];
      if (addonOn() && addon?.dataset.variantId) {
        items.push({ id: Number(addon.dataset.variantId), quantity: units });
      }
      await Cart.add(items);
      if (skipCart) window.location.href = "/checkout";
    });
  };

  const initQuotes = (root) => {
    const quotes = [...root.querySelectorAll("[data-quote]")];
    if (quotes.length < 2) return;
    let i = 0;
    setInterval(() => {
      i = (i + 1) % quotes.length;
      quotes.forEach((q, idx) => { q.hidden = idx !== i; });
    }, 8000);
  };

  const initFaq = (root) => {
    root.querySelectorAll("[data-faq-item]").forEach((item) => {
      item.querySelector("[data-faq-q]")?.addEventListener("click", () => {
        const open = item.classList.contains("is-open");
        root.querySelectorAll("[data-faq-item]").forEach((el) => el.classList.remove("is-open"));
        if (!open) item.classList.add("is-open");
      });
    });
  };

  const initReviews = (root) => {
    const tabs = [...root.querySelectorAll("[data-tab]")];
    const cards = [...root.querySelectorAll("[data-review]")];
    const countEl = root.querySelector("[data-review-count]");
    const rail = root.querySelector("[data-rail]");
    const wrap = root.querySelector("[data-rail-wrap]");
    const step = (dir) => {
      if (!rail) return;
      rail.scrollBy({ left: dir * 372, behavior: "smooth" });
    };
    const onScroll = () => wrap?.classList.toggle("is-scrolled", (rail?.scrollLeft || 0) > 8);
    const apply = (tag) => {
      tabs.forEach((tab) => tab.classList.toggle("is-on", tab.dataset.tab === tag));
      let visible = 0;
      cards.forEach((card) => {
        const show = tag === "All" || card.dataset.tag === tag;
        card.classList.toggle("is-hidden", !show);
        if (show) visible += 1;
      });
      if (countEl) countEl.textContent = String(visible);
      if (rail) rail.scrollTo({ left: 0, behavior: "smooth" });
      onScroll();
    };
    tabs.forEach((tab) => tab.addEventListener("click", () => apply(tab.dataset.tab)));
    root.querySelector("[data-rail-prev]")?.addEventListener("click", () => step(-1));
    root.querySelector("[data-rail-next]")?.addEventListener("click", () => step(1));
    rail?.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  };

  const initStock = (root) => {
    const el = root.querySelector("[data-stock-left]");
    if (!el) return;
    const start = Number(el.dataset.start || el.textContent || 74);
    const key = "wl_stock_left";
    const saved = Number(window.localStorage.getItem(key) || "");
    let stock = Number.isFinite(saved) && saved > 11 && saved <= start ? saved : start;
    const paint = () => { el.textContent = String(stock); };
    paint();
    setInterval(() => {
      if (stock > 12) {
        stock -= 1;
        try { window.localStorage.setItem(key, String(stock)); } catch (e) {}
        paint();
      }
    }, 38000);
  };

  const initVideos = (root) => {
    if (root.__wlVideos) return;
    root.__wlVideos = true;
    const cards = [...root.querySelectorAll(".wl-video")];
    cards.forEach((card) => {
      const video = card.querySelector("[data-ugc-video]");
      const frame = card.querySelector(".wl-video__frame");
      if (!video || !frame) return;
      const paint = () => card.classList.toggle("is-playing", !video.paused);
      const play = () => {
        video.muted = true;
        video.defaultMuted = true;
        video.volume = 0;
        video.loop = true;
        video.playsInline = true;
        const attempt = video.play();
        if (attempt && typeof attempt.catch === "function") attempt.catch(() => paint());
        paint();
      };
      video.addEventListener("playing", paint);
      video.addEventListener("pause", paint);
      if (!frame.__wlBound) {
        frame.__wlBound = true;
        frame.addEventListener("click", () => {
          if (video.paused) play();
          else video.pause();
        });
      }
      play();
    });
  };

  const initSocial = (root) => {
    const grid = root.querySelector(".wl-posts");
    const nav = root.querySelector(".wl-social__nav");
    if (!grid || !nav || grid.__wlSocialInit) return;
    grid.__wlSocialInit = true;
    const posts = grid.querySelectorAll(".wl-post");
    const dotsWrap = nav.querySelector("[data-social-dots]");
    const dots = [];
    if (!posts.length || !dotsWrap) return;
    Array.prototype.forEach.call(posts, (_, idx) => {
      const b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", "Go to post " + (idx + 1));
      b.addEventListener("click", () => {
        grid.scrollTo({ left: grid.clientWidth * idx, behavior: "smooth" });
      });
      dotsWrap.appendChild(b);
      dots.push(b);
    });
    const current = () => (grid.clientWidth ? Math.round(grid.scrollLeft / grid.clientWidth) : 0);
    const sync = () => {
      const c = current();
      dots.forEach((d, idx) => d.classList.toggle("is-active", idx === c));
    };
    grid.addEventListener("scroll", () => { requestAnimationFrame(sync); }, { passive: true });
    nav.querySelector("[data-social-prev]")?.addEventListener("click", () => {
      grid.scrollBy({ left: -grid.clientWidth, behavior: "smooth" });
    });
    nav.querySelector("[data-social-next]")?.addEventListener("click", () => {
      grid.scrollBy({ left: grid.clientWidth, behavior: "smooth" });
    });
    sync();
  };

  const initSticky = (root) => {
    const cta = document.querySelector("[data-hero-cta]");
    const show = (on) => root.classList.toggle("is-visible", on);
    const update = (rect) => {
      const box = rect || cta?.getBoundingClientRect();
      show(Boolean(box) && box.bottom < 0);
    };
    if (cta && "IntersectionObserver" in window) {
      const io = new IntersectionObserver((entries) => {
        update(entries[0]?.boundingClientRect);
      }, { threshold: 0, rootMargin: "0px" });
      io.observe(cta);
      update();
      window.addEventListener("scroll", () => update(), { passive: true });
      window.addEventListener("resize", () => update());
    }
    root.querySelector("[data-sticky-cart]")?.addEventListener("click", () => {
      const form = document.querySelector("[data-product-form]");
      if (form?.requestSubmit) {
        form.requestSubmit();
        return;
      }
      if (form) {
        form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
        return;
      }
      Cart.open();
    });
  };

  const initAnnounce = (root) => {
    const track = root.querySelector("[data-announce-track]");
    if (!track) return;
    const slides = track.children.length;
    if (slides < 2) return;
    let i = 0;
    setInterval(() => {
      if (window.innerWidth > 860) {
        track.style.transform = "translateX(0)";
        return;
      }
      i = (i + 1) % slides;
      track.style.transform = `translateX(-${i * 100}%)`;
    }, 3200);
  };

  const initHeaderScroll = () => {
    const header = document.querySelector("[data-header]");
    if (!header) return;
    const section = header.closest(".shopify-section-header") || header;
    const mq = window.matchMedia("(max-width: 859px)");
    let currentScrollTop = 0;
    let headerTop = 0;
    let headerBottom = 0;
    const setHeight = () => {
      document.documentElement.style.setProperty("--header-height", `${section.offsetHeight}px`);
    };
    const measure = () => {
      setHeight();
      if (section.classList.contains("is-sticky")) return;
      const y = window.pageYOffset || document.documentElement.scrollTop;
      const rect = section.getBoundingClientRect();
      headerTop = rect.top + y;
      headerBottom = rect.bottom + y;
    };
    const hide = () => {
      if (!mq.matches || document.body.classList.contains("wl-nav-open")) return;
      section.classList.add("is-sticky", "is-hidden");
    };
    const reveal = () => {
      if (!mq.matches) return;
      section.classList.add("is-sticky", "is-animate");
      section.classList.remove("is-hidden");
    };
    const reset = () => {
      section.classList.remove("is-hidden", "is-sticky", "is-animate");
    };
    const onScroll = () => {
      if (!mq.matches) {
        if (section.classList.contains("is-sticky") || section.classList.contains("is-hidden")) reset();
        return;
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > currentScrollTop && scrollTop > headerBottom) {
        requestAnimationFrame(hide);
      } else if (scrollTop < currentScrollTop && scrollTop > headerBottom) {
        requestAnimationFrame(reveal);
      } else if (scrollTop <= headerTop) {
        requestAnimationFrame(reset);
      }
      currentScrollTop = scrollTop;
    };
    measure();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", () => {
      measure();
      onScroll();
    });
    mq.addEventListener("change", () => {
      measure();
      onScroll();
    });
  };

  const initMenu = () => {
    const btn = document.querySelector("[data-menu-open]");
    const drawer = document.querySelector("[data-nav-drawer]");
    if (!btn || !drawer) return;
    const setOpen = (open) => {
      drawer.classList.toggle("is-open", open);
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.classList.toggle("wl-nav-open", open);
    };
    btn.addEventListener("click", () => setOpen(!drawer.classList.contains("is-open")));
    drawer.querySelectorAll("[data-nav-close]").forEach((el) => {
      el.addEventListener("click", () => setOpen(false));
    });
    drawer.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => setOpen(false));
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") setOpen(false);
    });
  };

  const Cart = (() => {
    const SECTION = "cart-drawer";
    const TIMER_KEY = "wl-cart-reserve";
    const jsonHeaders = { "Content-Type": "application/json", Accept: "application/json" };
    const drawer = () => document.querySelector("[data-cart-drawer]");
    const wrap = () => document.querySelector(".shopify-section-cart-drawer");
    const syncCount = (n) => {
      document.querySelectorAll(".wl-cart [data-count]").forEach((el) => {
        el.dataset.count = String(n);
        el.textContent = String(n);
      });
    };
    const tickTimer = () => {
      const el = document.querySelector("[data-cart-timer]");
      if (!el) return;
      const duration = Math.max(1, Number(el.dataset.duration || 299));
      const now = Date.now();
      let until = Number(sessionStorage.getItem(TIMER_KEY) || 0);
      let left = Math.floor((until - now) / 1000);
      if (!until || left <= 0) {
        until = now + duration * 1000;
        sessionStorage.setItem(TIMER_KEY, String(until));
        left = duration;
      }
      const label = el.querySelector("[data-cart-timer-label]");
      if (label) {
        label.textContent = `${String(Math.floor(left / 60)).padStart(2, "0")}:${String(left % 60).padStart(2, "0")}`;
      }
    };
    const open = () => {
      const root = drawer();
      if (!root) return;
      root.classList.add("is-open");
      document.body.classList.add("wl-drawer-open");
      tickTimer();
    };
    const close = () => {
      drawer()?.classList.remove("is-open");
      document.body.classList.remove("wl-drawer-open");
    };
    const applyHtml = (html, keepOpen) => {
      const host = wrap();
      if (!host || !html) return;
      host.innerHTML = html;
      const root = drawer();
      const count = Number(root?.dataset.cartCount || 0);
      syncCount(count);
      if (count === 0) sessionStorage.removeItem(TIMER_KEY);
      if (keepOpen && count >= 0) open();
      tickTimer();
    };
    const refreshFromPage = async (keepOpen) => {
      const res = await fetch(`${window.Shopify?.routes?.root || "/"}?sections=${SECTION}`);
      const data = await res.json();
      applyHtml(data[SECTION], keepOpen);
    };
    const post = async (url, body, keepOpen = true) => {
      const payload = { ...body, sections: [SECTION], sections_url: window.location.pathname };
      const res = await fetch(url, { method: "POST", headers: jsonHeaders, body: JSON.stringify(payload) });
      const data = await res.json().catch(() => ({}));
      if (data.sections?.[SECTION]) applyHtml(data.sections[SECTION], keepOpen);
      else await refreshFromPage(keepOpen);
      return data;
    };
    const COVER_HANDLE = "medigel-cushion-cover";
    const PACK_ORDER = [4, 2, 1];
    let busy = false;
    const cartJson = () => fetch("/cart.js").then((res) => res.json());
    const packMap = () => {
      try {
        return JSON.parse(drawer()?.dataset.packs || "{}");
      } catch (e) {
        return {};
      }
    };
    const unitsOf = (item) => {
      const props = item.properties || {};
      const fromProp = Number(props._units || props._cushions);
      if (fromProp > 0) return fromProp;
      const text = `${item.variant_title || ""} ${item.product_title || ""}`;
      const match = text.match(/(\d+)\s*cushion/i);
      return match ? Number(match[1]) : 1;
    };
    const splitCart = (cart) => {
      const covers = [];
      const cushions = [];
      let cushionCount = 0;
      (cart.items || []).forEach((item) => {
        if ((item.handle || "") === COVER_HANDLE) covers.push(item);
        else {
          cushions.push(item);
          cushionCount += unitsOf(item) * Number(item.quantity || 0);
        }
      });
      return { covers, cushions, cushionCount };
    };
    const tierOf = (n) => (n >= 4 ? 4 : n >= 2 ? 2 : 1);
    const packItems = (n, map) => {
      const count = Math.max(0, Number(n) || 0);
      if (!count) return [];
      const id = Number(map[String(tierOf(count))] || 0);
      if (!id) return [];
      return [{ id, quantity: count, properties: { _units: "1" } }];
    };
    const silentPost = async (url, body) => {
      const res = await fetch(url, { method: "POST", headers: jsonHeaders, body: JSON.stringify(body) });
      return res.json().catch(() => ({}));
    };
    const snapPacks = async () => {
      const map = packMap();
      if (!Number(map["1"] || 0) && !Number(map["2"] || 0) && !Number(map["4"] || 0)) return false;
      const cart = await cartJson();
      const { cushions, cushionCount } = splitCart(cart);
      const want = packItems(cushionCount, map);
      const desired = {};
      want.forEach((item) => { desired[item.id] = item.quantity; });
      const have = {};
      let extra = false;
      cushions.forEach((item) => {
        const id = Number(item.variant_id);
        have[id] = (have[id] || 0) + Number(item.quantity || 0);
        if (!desired[id] && !Object.values(map).map(Number).includes(id)) extra = true;
      });
      const same = Object.keys(desired).every((id) => (have[Number(id)] || 0) === desired[id])
        && Object.keys(have).every((id) => (desired[Number(id)] || 0) === have[id])
        && !extra;
      if (same) return false;
      if (cushions.length) {
        const updates = {};
        cushions.forEach((item) => { updates[item.key] = 0; });
        await silentPost("/cart/update.js", { updates });
      }
      if (want.length) await silentPost("/cart/add.js", { items: want });
      return true;
    };
    const snapCovers = async () => {
      const cart = await cartJson();
      const { covers, cushionCount } = splitCart(cart);
      const updates = {};
      covers.slice(1).forEach((item) => { updates[item.key] = 0; });
      if (covers[0]) {
        const want = cushionCount > 0 ? cushionCount : 0;
        if (covers[0].quantity !== want) updates[covers[0].key] = want;
      }
      if (!Object.keys(updates).length) return false;
      await silentPost("/cart/update.js", { updates });
      return true;
    };
    const afterChange = async (keepOpen = true) => {
      await snapPacks();
      await snapCovers();
      await refreshFromPage(keepOpen);
    };
    const setCushionCount = async (next) => {
      if (busy) return;
      busy = true;
      try {
        const n = Math.max(0, Number(next) || 0);
        const cart = await cartJson();
        const { cushions, cushionCount } = splitCart(cart);
        if (n !== cushionCount) {
          if (cushions.length) {
            const updates = {};
            cushions.forEach((item) => { updates[item.key] = 0; });
            await silentPost("/cart/update.js", { updates });
          }
          const map = packMap();
          const items = packItems(n, map);
          if (items.length) await silentPost("/cart/add.js", { items });
        }
        await snapPacks();
        await snapCovers();
        await refreshFromPage(true);
        open();
      } finally {
        busy = false;
      }
    };
    const add = async (items) => {
      try {
        const next = (items || []).map((item) => ({ ...item }));
        await fetch("/cart/add.js", { method: "POST", headers: jsonHeaders, body: JSON.stringify({ items: next }) });
        await afterChange(true);
        open();
      } catch (e) {
        window.location.href = "/cart";
      }
    };
    const change = async (key, quantity) => {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: jsonHeaders,
        body: JSON.stringify({ id: key, quantity }),
      });
      await afterChange(true);
    };
    document.addEventListener("click", (event) => {
      if (event.target.closest("[data-cart-open]")) {
        event.preventDefault();
        open();
      }
      if (event.target.closest("[data-cart-close]")) close();
      const addBtn = event.target.closest("[data-addon-add]");
      if (addBtn) {
        event.preventDefault();
        const variantId = Number(addBtn.getAttribute("data-addon-add"));
        const qtyHost = drawer() || document.querySelector("[data-cushion-count]");
        const qty = Math.max(1, Number(qtyHost?.dataset.cushionCount || 1));
        add([{ id: variantId, quantity: qty }]);
      }
      const qtyBtn = event.target.closest("[data-qty-change]");
      if (qtyBtn) {
        const item = qtyBtn.closest("[data-key]");
        if (!item) return;
        const delta = qtyBtn.getAttribute("data-qty-change");
        if (item.hasAttribute("data-cover")) {
          if (delta === "remove") change(item.getAttribute("data-key"), 0);
          return;
        }
        if (item.hasAttribute("data-cushion")) {
          if (delta === "remove") {
            setCushionCount(0);
            return;
          }
          cartJson().then((cart) => {
            const { cushionCount } = splitCart(cart);
            setCushionCount(Math.max(0, cushionCount + Number(delta)));
          });
          return;
        }
        const input = item.querySelector("[data-qty-input]");
        const current = Number(input?.value || 1);
        const next = delta === "remove" ? 0 : Math.max(0, current + Number(delta));
        change(item.getAttribute("data-key"), next);
      }
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") close();
    });
    document.addEventListener("change", (event) => {
      const input = event.target.closest("[data-qty-input]");
      if (!input) return;
      const item = input.closest("[data-key]");
      if (!item || item.hasAttribute("data-cover")) return;
      if (item.hasAttribute("data-cushion")) {
        setCushionCount(Math.max(0, Number(input.value || 0)));
        return;
      }
      change(item.getAttribute("data-key"), Math.max(0, Number(input.value || 0)));
    });
    setInterval(tickTimer, 1000);
    tickTimer();
    syncCount(Number(drawer()?.dataset.cartCount || 0));
    (async () => {
      const packed = await snapPacks();
      const covered = await snapCovers();
      if (packed || covered) await refreshFromPage(false);
    })().catch(() => {});
    return { add, open, close };
  })();

  const initArrival = () => {
    const els = document.querySelectorAll("[data-arrival-date]");
    if (!els.length) return;
    const d = new Date();
    d.setDate(d.getDate() + 9);
    const label = d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
    els.forEach((el) => { el.textContent = label; });
  };

  const boot = (sel, fn) => {
    document.querySelectorAll(sel).forEach((el) => {
      try { fn(el); } catch (e) {}
    });
  };
  boot("[data-gallery]", initGallery);
  boot("[data-offer]", initOffer);
  boot("[data-quotes]", initQuotes);
  boot("[data-faq]", initFaq);
  boot("[data-reviews]", initReviews);
  boot("[data-stock]", initStock);
  boot("[data-videos]", initVideos);
  boot("[data-sticky-bar]", initSticky);
  boot("[data-announce]", initAnnounce);
  boot("[data-social-carousel]", initSocial);
  try { initHeaderScroll(); } catch (e) {}
  try { initMenu(); } catch (e) {}
  try { initArrival(); } catch (e) {}
})();
